import React from 'react';

// "My roles" as a vector diagram (redrawn from roles.png): three overlapping roles inside a ring of themes, with the
// three activities as satellites. Colours come from the palette (--site-night-c1/c2/c3 on the black page).
// three equal circles on an equilateral triangle (side 440) around the ring's centre, so every pair overlaps by the same
// amount; each label is centred on its circle
const R = 320;
const CIRCLES = [
  { id: 'c1', cx: 750, cy: 506, lines: ['Computer Scientist'] },
  { id: 'c2', cx: 530, cy: 887, lines: ['Computational', 'Social Scientist'] },
  { id: 'c3', cx: 970, cy: 887, lines: ['Data Artist'] },
];
const SATELLITES = [
  { cx: 220, cy: 455, lines: ['UNDERSTA', 'NDING'] },
  { cx: 1260, cy: 440, lines: ['DECISION-', 'MAKING'] },
  { cx: 745, cy: 1355, lines: ['COMMUNI', 'CATING'] },
];

const RolesDiagram: React.FC = () => (
  <svg className='roles-svg' viewBox='0 0 1500 1500' role='img'
    aria-label='My roles: a computer scientist, a computational social scientist and a data artist, around understanding, decision-making and communicating, within social dynamics, human behavior and humanistic concern.'>
    <defs>
      {CIRCLES.map(c => (
        <radialGradient key={c.id} id={`roles-${c.id}`} cx='50%' cy='45%' r='60%'>
          <stop offset='0%' style={{ stopColor: `var(--site-night-${c.id})`, stopOpacity: 0.95 }} />
          <stop offset='100%' style={{ stopColor: `var(--site-night-${c.id})`, stopOpacity: 0.6 }} />
        </radialGradient>
      ))}
      {/* the ring's labels run along these arcs: over the top (left to right) and under the bottom (left to right) */}
      <path id='roles-arc-top' d='M 47 747 A 700 700 0 0 1 1447 747' fill='none' />
      <path id='roles-arc-bottom' d='M 47 747 A 700 700 0 0 0 1447 747' fill='none' />
    </defs>

    <circle cx='747' cy='747' r='742' className='roles-ring' />
    <text className='roles-ring-label'><textPath href='#roles-arc-top' startOffset='50%' textAnchor='middle'>SOCIAL DYNAMICS</textPath></text>
    <text className='roles-ring-label'><textPath href='#roles-arc-bottom' startOffset='16%' textAnchor='middle'>HUMAN BEHAVIOR</textPath></text>
    <text className='roles-ring-label'><textPath href='#roles-arc-bottom' startOffset='84%' textAnchor='middle'>HUMANISTIC CONCERN</textPath></text>

    <g className='roles-blend'>
      {CIRCLES.map(c => <circle key={c.id} cx={c.cx} cy={c.cy} r={R} fill={`url(#roles-${c.id})`} />)}
    </g>
    {CIRCLES.map(c => (
      <text key={c.id} className='roles-label' x={c.cx} y={c.cy} textAnchor='middle' dominantBaseline='central'>
        {c.lines.map((l, i) => <tspan key={i} x={c.cx} dy={i ? 46 : -23 * (c.lines.length - 1)}>{l}</tspan>)}
      </text>
    ))}

    {SATELLITES.map(s => (
      <g key={s.lines.join('')}>
        <circle cx={s.cx} cy={s.cy} r='110' className='roles-sat' />
        {s.lines.map((l, i) => <text key={i} className='roles-sat-label' x={s.cx} y={s.cy - 12 + i * 46} textAnchor='middle'>{l}</text>)}
      </g>
    ))}
  </svg>
);

export default RolesDiagram;
